import type { ParentTypeEnum } from '@gql/graphql';
import type {
  CardItemBreedData,
  CardItemBreederData,
  CardItemLitterData,
  ContactInfoData,
  HeaderProfileData,
  SlideshowData,
} from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler, ReactNode } from 'react';

export type LitterPageInfoDetailIcon = 'check' | 'cross' | 'calendar';

export interface DogParentData {
  type: ParentTypeEnum;
  name: string;
  image?: string;
  pedigreeType?: string;
  pedigreeNumber?: string;
  titles?: string;
  age?: string;
  microchipNumber?: string;
  testResults?: string;
  onImageClick?: () => void;
}

export interface LitterPageInfoDetail {
  label: string;
  value: string;
  icon?: LitterPageInfoDetailIcon;
  tooltip?: string;
}

export interface LitterPageData {
  header?: HeaderProfileData;
  breedName: string;

  onWishlistClick?: MouseEventHandler;
  isWishlisted?: boolean;
  wishlistLoading?: boolean;
  showWishlist?: boolean;

  onSocialShareClick: () => void;

  hasPedigree: boolean;
  details: LitterPageInfoDetail[];
  slideshow?: SlideshowData;

  parents?: DogParentData[];

  breedCard?: CardItemBreedData;
  description?: string;

  contactInfo?: ContactInfoData;
  cardContact?: ReactNode;

  litterItems?: CardItemLitterData[];
  breederItems?: CardItemBreederData[];

  litterItemsLoading?: boolean;
  breederItemsLoading?: boolean;

  moreLittersLink: LocationDescriptor;
  moreBreedersLink: LocationDescriptor;

  warning?: string;
  showApplyButton?: boolean;

  onOpenBuyerChecklist(): void;
  enableWhatsAppContact?: boolean;
  onWhatsappClick: () => void;
}
export interface LitterPageBreederData {
  id: number;
  whatsappNumber?: string | null;
}

export interface LitterPageProps extends LitterPageData {}
